export enum AuthStatus {
  LoggedIn,
  LoggedOut
}
